import { gql } from '@apollo/client';

export const GET_TWILLIO_SAVED_DATA = gql`
query FindTextSettings {
  findTextSettings {
    _id
    accountSid
    authToken
    senderMobile
    toMobile
    userId
  }
}
`